import { ChangeDetectionStrategy, Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lqa-confirm-dialog',
  templateUrl: './lqa-confirm-dialog.component.html',
  styleUrls: ['./lqa-confirm-dialog.component.scss']
})
export class LqaConfirmDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public message: string,
              private dialogRef: MatDialogRef<LqaConfirmDialogComponent>) { }

  public cancel(): void{
    this.close(false);
  }

  public close(value: boolean): void{
    this.dialogRef.close(value);
  }

  public confirm(): void{
    this.close(true);
  }

  @HostListener("keydown.esc")
  public onEsc(): void{
    this.close(false);
  }

}
